export const MARGIN = 5;
export const GAP_BETWEEN_COLUMNS = 30;
export const LABEL_FONT_SIZE = 16;
export const LABEL_RECT_RADIUS = 4;
export const LABEL_HEIGHT = 20;
